import { Component, inject, input } from '@angular/core';
import { SyncStatusService } from '../../../core/services/sync-status.service';

/** Status de sincronização exibido no rodapé do sidebar — origem: SyncStatusService (stub). */
@Component({
  selector: 'app-sync-status',
  standalone: true,
  imports: [],
  templateUrl: './sync-status.component.html',
  styleUrl: './sync-status.component.scss',
})
export class SyncStatusComponent {
  private readonly syncStatusService = inject(SyncStatusService);

  readonly collapsed = input<boolean>(false);
  readonly status = this.syncStatusService.status;

  /** TODO: abrirá a visão de sincronizações — sem funcionalidade ainda (issue #126 é refino de layout). */
  onOpen(): void {}
}
